<div
  class="subscribed-card-container"
  [class.selected]="isSelected"
  [class.preview]="isPreview"
  [class.loading]="isLoading"
>
  <div class="loading-cover">
    <div class="cssload-speeding-wheel"></div>
  </div>
  <h2 class="title">{{ plan?.name | translate }}</h2>

  <div class="price-block">
    <p class="price">
      {{ currencyExchangeSymbol
      }}{{
        showMonthly
          ? (priceForMonth?.price | number : '.0-0')
          : (priceForYear?.price | number : '.0-0')
      }}
    </p>
    <p class="billing b-0">
      {{
        showMonthly
          ? ('OPS_SUBSCRIBED_CARD.BILLED_MONTHLY' | translate)
          : ('OPS_SUBSCRIBED_CARD.BILLED_YEARLY' | translate)
      }}
    </p>
  </div>

  <ul class="features">
    <li>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="21"
        viewBox="0 0 20 21"
        fill="none"
      >
        <circle cx="10" cy="10.5" r="10" fill="#53FBB4" />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M4.54883 10.3059L8.43376 13.9991L14.6756 5.95459"
          fill="#53FBB4"
        />
        <path
          d="M4.54883 10.3059L8.43376 13.9991L14.6756 5.95459"
          stroke="black"
        />
      </svg>
      &nbsp;{{ 'OPS_SUBSCRIBED_CARD.ACTIVE_PROJECTS' | translate }}:
      {{ subscriptionData?.limitations?.maxRealProjectsInCompany }}
      <!-- {{ plan.limitations?.maxRealProjectsInCompany }} -->
    </li>

    <!-- <li>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="21"
        viewBox="0 0 20 21"
        fill="none"
      >
        <circle cx="10" cy="10.5" r="10" fill="#53FBB4" />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M4.54883 10.3059L8.43376 13.9991L14.6756 5.95459"
          fill="#53FBB4"
        />
        <path
          d="M4.54883 10.3059L8.43376 13.9991L14.6756 5.95459"
          stroke="black"
        />
      </svg>
      &nbsp;Users: {{ subscriptionData?.limitations?.maxUserPerCompany }}
      {{ plan.limitations?.maxUserPerCompany }}
    </li> -->
  </ul>

  <div class="add-ons-block">
    <p class="add-ons-title">{{ 'OPS_SUBSCRIBED_CARD.ADD_ONS' | translate }}</p>
    <div *ngFor="let addOn of addOns" class="add-ons-button-wrapper">
      <div class="add-ons-button" [class.highlighted]="hasExtraItem(addOn)">
        {{ addOn?.name | translate }}
        {{ currencyExchangeSymbol
        }}{{ showMonthly ? (addOn?.monthly?.[selectedCurrency]?.price | number : '.0-0') : (addOn?.yearly?.[selectedCurrency]?.price | number : '.0-0')  }}

        <div class="active-addons">+{{ getExtraCount(addOn) }}</div>
      </div>
      <svg
        *ngIf="!isCanceledSubscription"
        (click)="onAddExtraItem(addOn)"
        xmlns="http://www.w3.org/2000/svg"
        width="22"
        height="22"
        viewBox="0 0 22 22"
        fill="none"
      >
        <path
          d="M10.9997 7.3335V14.6668M14.6663 11.0002H7.33301M10.9997 20.1668C16.0623 20.1668 20.1663 16.0628 20.1663 11.0002C20.1663 5.93755 16.0623 1.8335 10.9997 1.8335C5.93706 1.8335 1.83301 5.93755 1.83301 11.0002C1.83301 16.0628 5.93706 20.1668 10.9997 20.1668Z"
          stroke="#00A8FF"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
      <svg
        *ngIf="hasExtraItem(addOn) && !isCanceledSubscription"
        (click)="onRemoveExtraItem(addOn)"
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
      >
        <circle cx="10" cy="10" r="9" stroke="#FF6060" />
        <line x1="5" y1="10" x2="15" y2="10" stroke="#FF6060" />
      </svg>
    </div>
  </div>

  <!-- <ul class="features"> -->
  <!-- <li *ngFor="let item of plan.metadata">
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
        <circle cx="10" cy="10.5" r="10" fill="#53FBB4" />
        <path fill-rule="evenodd" clip-rule="evenodd" d="M4.54883 10.3059L8.43376 13.9991L14.6756 5.95459"
          fill="#53FBB4" />
        <path d="M4.54883 10.3059L8.43376 13.9991L14.6756 5.95459" stroke="black" />
      </svg>
      {{ item }}
    </li> -->
  <!-- </ul> -->
  <!-- (isCanceledSubscription && !subscriptionData?.withActiveSubscription) || -->
  <button
    *ngIf="
      
      !isCanceledSubscription
    "
    [disabled]="isDisabled"
    class="btn active"
    (click)="onChangeCurrentPlan()"
  >
    {{
      isCanceledSubscription
        ? ('OPS_SUBSCRIBED_CARD.BUY_NEW_PLAN' | translate)
        : ('OPS_SUBSCRIBED_CARD.CHANGE_PLAN' | translate)
    }}
  </button>
  <button
    *ngIf="(isCanceledSubscription && !subscriptionData?.withActiveSubscription) && !subscriptionData.cancellationRequested"
    [disabled]="isDisabled"
    class="btn active"
    (click)="onResumeSubscription()"
  >
    {{ 'OPS_SUBSCRIBED_CARD.RESUME_SUBSCRIPTION' | translate }}
  </button>
  <button
    *ngIf="!isCanceledSubscription"
    [disabled]="isDisabled"
    class="btn-cancel"
    (click)="onCancelSubscription()"
  >
    {{ 'OPS_SUBSCRIBED_CARD.CANCEL_SUBSCRIPTION' | translate }}
  </button>
</div>
